import { analyzeMakeupFluxPromptV3, resolveMakeupFluxPromptV3 } from '../../makeup-flux-prompt-v3/utils/makeupFluxPromptV3Api';
import { getMakeupHairApiBaseUrl } from '../../makeuphair/utils/apiConfig';
import { kioskAuthHeaders } from '../../makeuphair/utils/kioskAuthHeaders';
import { getFranchiseOrganizationId } from '../../shared/franchiseFlowAuth';

function base() {
  return `${getMakeupHairApiBaseUrl().replace(/\/$/, '')}/api/makeup-flux-lab`;
}

function withOrg(path) {
  const orgId = getFranchiseOrganizationId();
  if (!orgId) return path;
  const join = path.includes('?') ? '&' : '?';
  return `${path}${join}organization_id=${encodeURIComponent(String(orgId))}`;
}

export async function fetchMakeupFluxLabBuildInfo() {
  const res = await fetch(`${base()}/build-info`, { credentials: 'include' });
  return res.json();
}

/**
 * Guest analysis for FLUX Lab / Makeup v3 (Gemma vision + palette resolve).
 */
export async function analyzeGuestForFluxLab(imageDataUrl) {
  const studio = await analyzeMakeupFluxPromptV3(imageDataUrl, undefined, true);
  const skin = studio?.skin_profile;
  const lip = studio?.lip_profile;
  if (!skin?.depth && !skin?.lab) {
    return {
      success: false,
      error: 'Could not analyze guest (Gemma / studio analyze failed)',
    };
  }
  const gemma = studio?.analysis?.gemma;
  return {
    success: true,
    source: 'gemma_studio',
    skin_profile: skin,
    lip_profile: lip,
    gemma,
    analysis_quality: studio?.analysis?.analysis_quality,
    foundation_hex: skin?.foundation_hex,
  };
}

export async function resolveStudioMakeupForFluxLook({
  fluxLookId,
  studioPresetId,
  skinProfile,
  lipProfile,
  overrides,
}) {
  return resolveMakeupFluxPromptV3({
    preset: studioPresetId,
    skinProfile,
    lipProfile,
    overrides,
    fluxLookId,
  });
}

export async function generateMakeupFluxLab({
  image,
  prompt,
  lookId,
  makeupLab,
  skinTone,
  customMakeup,
}) {
  const res = await fetch(`${base()}${withOrg('/generate')}`, {
    method: 'POST',
    credentials: 'include',
    headers: kioskAuthHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      image,
      prompt,
      look_id: lookId || undefined,
      makeup_lab: makeupLab || undefined,
      skin_tone: skinTone || undefined,
      custom_makeup: customMakeup ? true : undefined,
      wrap_identity: true,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    const err = new Error(data?.error || `Request failed (${res.status})`);
    err.code = data?.code;
    err.status = res.status;
    throw err;
  }
  return data;
}
